import React from 'react';
import {
  DataTable, IconPencil,
} from '@skf/bt-wind-rail-commonlibrary';
import style from './RoleManagementListDataTable.module.scss';
import { Role } from '../../../../../store/roles/types';
import { useTranslation } from 'react-i18next';
import { orderByAlphabetical } from '../../../../../services/stringServices';

interface IRoleManagementListTableProps {
  roles?: Role[];
  onEditRole?: (role: Role) => void;
}

const RoleManagementListDataTable: React.FunctionComponent<IRoleManagementListTableProps> = (
  {
    roles = [],
    onEditRole = () => ''
  }
) => {
  const { t } = useTranslation();

  const columns: any[] = [
    {
      Header: t('Name'),
      accessor: 'name',
      className: style.columnName,
    },
    {
      Header: t('Portal_Name'),
      accessor: 'btPortalIndustry',
      className: style.columnPortalName,
    },
    {
      Header: t('Industry_Name'),
      accessor: 'industryName',
      className: style.columnIndustryName,
    },
    {
      Header: t('Priority'),
      accessor: 'priority',
      className: style.columnPriority,
    },
    {
      Header: t('User_Web_Roles'),
      className: style.columnRoles,
      accessor: (role: Role) => role.userWebRoles?.sort(orderByAlphabetical).join(', '),
      sortMethod: (r1: string, r2: string) => r1.localeCompare(r2)
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnActions,
      Cell: ({ row }: any) => {
        const { original: role } = row;
        return (
          <div className={style.iconsColumns}>
            <IconPencil
              className={style.cursorPointer}
              onClick={() => onEditRole(role)}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={roles}
      className={style.table}
      pagination={20}
    />
  );
};

export default RoleManagementListDataTable;
